import React from "react"
import MySimpleSpinner from "@common-utils/MySimpleSpinner"

interface Props {
     isExtracting: boolean
     isDragging: boolean
     setIsDragging: (val: boolean) => void
     onDrop: (files: FileList | null) => void
     availableCount: number
     fileInputRef: React.RefObject<HTMLInputElement>
}

const Step2FileDropzone = ({ isExtracting, isDragging, setIsDragging, onDrop, availableCount, fileInputRef }: Props) => {
     if (isExtracting) {
          return (
               <div className="py-15 text-center bg-light-primary border border-primary rounded">
                    <div className="mb-5">
                         <MySimpleSpinner size="xl" />
                    </div>
                    <h4 className="fw-bolder text-primary mb-2 fs-3">Analyse des documents en cours...</h4>
                    <p className="text-gray-600 fw-semibold fs-6 mb-0">
                         Nous analysons vos factures afin d’extraire automatiquement les noms, les jours travaillés et les montants.
                    </p>
               </div>
          )
     }

     return (
          <div
               className={`rounded border-2 border-dashed p-10 text-center transition-all ${isDragging ? "border-primary bg-light-primary scale-102" : "border-gray-400 bg-body"}`}
               onDragOver={e => {
                    e.preventDefault()
                    setIsDragging(true)
               }}
               onDragLeave={() => setIsDragging(false)}
               onDrop={e => {
                    e.preventDefault()
                    setIsDragging(false)
                    onDrop(e.dataTransfer.files)
               }}
               onClick={() => fileInputRef.current?.click()}
               style={{ cursor: "pointer", transition: "all 0.2s" }}
          >
               <input type="file" multiple ref={fileInputRef} className="d-none" onChange={e => onDrop(e.target.files)} />
               <i className="fas fa-cloud-upload-alt fs-3x text-primary mb-8"></i>
               <h3 className="fw-boldest fs-2 mb-3">2. Importez vos factures de prestation (sans justificatifs)</h3>
               <p className="text-gray-600 fs-6 mb-0 px-10">
                    Glissez vos fichiers ici ou cliquez pour parcourir. Notre système va
                    <strong> extraire automatiquement</strong> les données pour vous.
               </p>

               <div className="mt-4 py-2 px-4 bg-light-info rounded-2 d-inline-block border border-info border-dashed">
                    <span className="fs-7 text-info fw-bold">
                         <i className="fas fa-info-circle me-2"></i>
                         <strong>Note :</strong> Vous pouvez envoyer un PDF groupé, à condition d'avoir <span className="fw-bolder">une facture unique par page</span>.
                    </span>
               </div>
          </div>
     )
}

export default Step2FileDropzone
